import { LegalPageLayout, COMPANY_INFO } from './LegalPage';

const PolitiqueConfidentialite = () => {
  return (
    <LegalPageLayout title="Politique de confidentialité (RGPD)">
      <p>
        La présente Politique de confidentialité a pour objet d'informer les utilisateurs du site
        <strong> notabenesympho.be</strong> sur la manière dont leurs données personnelles sont collectées
        et traitées, conformément au Règlement Général sur la Protection des Données (Règlement UE 2016/679 — RGPD)
        et à la loi belge du 30 juillet 2018 relative à la protection des personnes physiques à l'égard des
        traitements de données à caractère personnel.
      </p>

      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement est :<br />
        <strong>{COMPANY_INFO.name}</strong><br />
        {COMPANY_INFO.address}<br />
        Email : <strong>{COMPANY_INFO.email}</strong><br />
        Téléphone : {COMPANY_INFO.phone}
      </p>

      <h2>2. Données collectées</h2>
      <p>Nous collectons les données suivantes lorsque vous utilisez notre site :</p>
      <ul>
        <li><strong>Pour passer une commande :</strong> nom, prénom, numéro de téléphone, adresse email
          (optionnelle), adresse de livraison (si applicable), contenu de la commande.</li>
        <li><strong>Pour réserver une table :</strong> nom, téléphone, email (optionnel), date/heure,
          nombre de couverts.</li>
        <li><strong>Données techniques :</strong> adresse IP, type de navigateur, pages visitées
          (via cookies essentiels — voir notre <a href="/politique-cookies" className="text-[#C62E2E]">
          Politique de cookies</a>).</li>
        <li><strong>Données de paiement :</strong> en cas de paiement par carte, les données sont traitées
          directement par notre prestataire Stripe. <strong>Aucune donnée bancaire n'est stockée sur nos serveurs.</strong></li>
      </ul>

      <h2>3. Finalités du traitement</h2>
      <p>Vos données sont utilisées uniquement pour les finalités suivantes :</p>
      <ul>
        <li>Traiter et livrer vos commandes</li>
        <li>Gérer vos réservations de table</li>
        <li>Vous envoyer des confirmations de commande ou de réservation par email</li>
        <li>Répondre à vos demandes de contact</li>
        <li>Respecter nos obligations légales et comptables</li>
      </ul>
      <p>
        Nous <strong>ne vendons jamais</strong> vos données à des tiers et nous ne les utilisons pas à des
        fins publicitaires sans votre consentement explicite.
      </p>

      <h2>4. Base juridique du traitement</h2>
      <p>Le traitement de vos données est fondé sur :</p>
      <ul>
        <li>L'<strong>exécution du contrat</strong> (commande, réservation) — art. 6.1.b RGPD</li>
        <li>Le <strong>respect d'obligations légales</strong> (facturation, TVA) — art. 6.1.c RGPD</li>
        <li>Notre <strong>intérêt légitime</strong> à assurer le bon fonctionnement du service — art. 6.1.f RGPD</li>
      </ul>

      <h2>5. Durée de conservation</h2>
      <ul>
        <li><strong>Données de commande :</strong> 10 ans (obligation légale comptable belge)</li>
        <li><strong>Données de réservation :</strong> 1 an après la date de réservation</li>
        <li><strong>Demandes de contact :</strong> 1 an</li>
        <li><strong>Cookies :</strong> voir notre <a href="/politique-cookies" className="text-[#C62E2E]">
          Politique de cookies</a></li>
      </ul>

      <h2>6. Destinataires des données</h2>
      <p>Vos données peuvent être transmises à :</p>
      <ul>
        <li>Nos prestataires techniques (hébergement, envoi d'emails, paiement Stripe) — liés par des accords
          de confidentialité conformes au RGPD.</li>
        <li>Les autorités administratives ou judiciaires, uniquement sur requête légale.</li>
      </ul>

      <h2>7. Vos droits</h2>
      <p>Conformément au RGPD, vous disposez des droits suivants sur vos données :</p>
      <ul>
        <li><strong>Droit d'accès</strong> : connaître les données que nous détenons sur vous</li>
        <li><strong>Droit de rectification</strong> : corriger des données inexactes</li>
        <li><strong>Droit à l'effacement</strong> (« droit à l'oubli ») : demander la suppression
          sous réserve de nos obligations légales</li>
        <li><strong>Droit à la limitation</strong> du traitement</li>
        <li><strong>Droit à la portabilité</strong> de vos données</li>
        <li><strong>Droit d'opposition</strong> au traitement</li>
      </ul>
      <p>
        Pour exercer ces droits, contactez-nous à l'adresse : <strong>{COMPANY_INFO.email}</strong>.
        Nous répondrons dans un délai maximum d'un mois.
      </p>

      <h2>8. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles appropriées (chiffrement SSL/HTTPS,
        accès restreint, sauvegardes régulières) pour protéger vos données contre toute perte, altération ou
        accès non autorisé.
      </p>

      <h2>9. Transferts hors UE</h2>
      <p>
        Nos prestataires (Stripe, service d'envoi d'emails) peuvent être amenés à traiter des données en dehors
        de l'Union Européenne. Dans ce cas, ces transferts sont encadrés par des clauses contractuelles types
        conformément à l'article 46 du RGPD.
      </p>

      <h2>10. Plainte auprès d'une autorité de contrôle</h2>
      <p>
        Si vous estimez que vos droits n'ont pas été respectés, vous pouvez introduire une réclamation auprès de l'
        <strong>Autorité de protection des données (APD)</strong> belge :
      </p>
      <p>
        Rue de la Presse 35, 1000 Bruxelles<br />
        Tél. : +32 (0)2 274 48 00<br />
        Email : contact@apd-gba.be<br />
        Site : <a href="https://www.autoriteprotectiondonnees.be" target="_blank" rel="noopener noreferrer"
          className="text-[#C62E2E]">www.autoriteprotectiondonnees.be</a>
      </p>

      <h2>11. Modifications</h2>
      <p>
        La présente politique peut être modifiée à tout moment pour se conformer à l'évolution légale ou
        technique. La date de dernière mise à jour figure en haut de ce document.
      </p>
    </LegalPageLayout>
  );
};

export default PolitiqueConfidentialite;
